import { FlyerType } from '../model/templates'

export type Step = 'destination' | 'itinerary' | 'priceList' | 'agentDetails' | 'notes' | 'flyer'

export type StepOrder = { [key in FlyerType]: Step[] }

export const initialStepOrder: StepOrder = {
	tactical: ['destination', 'itinerary', 'priceList', 'notes', 'agentDetails', 'flyer'],
	product: ['agentDetails', 'flyer'],
}
